export enum Role {
  ADMIN = "tak_user_admin",
}
